import React, { memo } from "react";
import Logo from "../../../assets/images/wifi-attendance.svg";

// An organisation without a logo gets ".../assets/uploads/" from the
// login reply — the uploads folder with no file name — which fetched
// a 404 on every page before onError swapped in the bundled logo.
const hasLogo = (url) =>
  Boolean(url) && !/^(null|undefined)$/.test(url) && !/\/assets\/uploads\/?$/.test(url);

const LogoBlock = ({ collapsed, companyLogo, onLogoClick }) => {
  const src = hasLogo(companyLogo) ? companyLogo : Logo;

  return (
    <button
      type="button"
      className={
        collapsed ? "sb-sidebar__brand sb-sidebar__brand--mini" : "sb-sidebar__brand"
      }
      onClick={onLogoClick}
      aria-label="Go to home"
    >
      <img
        src={src}
        alt="Logo"
        className="sb-sidebar__brand-img"
        onError={(e) => {
          e.target.src = Logo;
        }}
      />
    </button>
  );
};

export default memo(LogoBlock);
